module.exports = __webpack_public_path__ + "static/media/value_prop_img_2.1f9e8764.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-SPRINT/value_prop_img_2.jpg
// module id = 2665
// module chunks = 0